// extracted by mini-css-extract-plugin
module.exports = {"LbDashboardCol":"LbDashboardCol_0cvRI"};